/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_New_Values_TitleInputs */

const cs_ebr_new_values_title = /** @type {(inputs: Ebr_New_Values_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nové hodnoty`)
};

const en_ebr_new_values_title = /** @type {(inputs: Ebr_New_Values_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New values`)
};

/**
* | output |
* | --- |
* | "New values" |
*
* @param {Ebr_New_Values_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_new_values_title = /** @type {((inputs?: Ebr_New_Values_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_New_Values_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_new_values_title(inputs)
	return cs_ebr_new_values_title(inputs)
});